import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./http";

/*
 * Cache policy is where "feels instant" is actually won.
 *
 * The defaults below mean a return visit to a screen renders from cache on the
 * same frame as the navigation, then reconciles in the background. Without a
 * staleTime, every navigation refetches and every screen flashes a spinner —
 * which is the difference users describe as "slow" even when the animations are
 * perfect.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      /* 30s: long enough that moving between screens is instant, short enough
       * that a dashboard of live signals is never meaningfully stale. */
      staleTime: 30_000,
      /* Keep evicted data around so a back-navigation has something to paint. */
      gcTime: 5 * 60_000,

      /* Refetching on every window focus makes a dashboard thrash when the user
       * alt-tabs. Reconnect is kept: that one is genuinely new information. */
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,

      retry: (failureCount, error) => {
        /* Never retry a contract mismatch or an auth failure — the second
         * attempt fails identically and only delays the error state. */
        if (error instanceof ApiError && !error.retryable) return false;
        return failureCount < 2;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
    mutations: {
      retry: false,
    },
  },
});
